import type { AllRouteEndpoints } from "../routeTypes";
export const engagementCampaignScheduleSummaryCacheKeys: AllRouteEndpoints[] = [];
